module.exports = __webpack_public_path__ + "img/Image46.54d70373.png";